import React from 'react'
// libs
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 45px;
  aspect-ratio: 1;
  --c: no-repeat linear-gradient(currentColor 0 0);
  background: var(--c) 0% 0%, var(--c) 50% 0%, var(--c) 100% 0%;
  background-color: transparent;
  animation: l2 1s infinite linear;
  transform: rotate(270deg);

  background-image: linear-gradient(#2d323d, #2d323d), linear-gradient(#0990af, #0990af),
    linear-gradient(#9238a1, #9238a1);

  @keyframes l2 {
    0% {
      background-size: 20% 100%, 20% 100%, 20% 100%;
    }
    20% {
      background-size: 20% 60%, 20% 100%, 20% 100%;
    }
    40% {
      background-size: 20% 80%, 20% 60%, 20% 100%;
    }
    60% {
      background-size: 20% 100%, 20% 80%, 20% 60%;
    }
    80% {
      background-size: 20% 100%, 20% 100%, 20% 80%;
    }
    100% {
      background-size: 20% 100%, 20% 100%, 20% 100%;
    }
  }
`

const SkeftoLoader: React.FC = () => {
  return <Wrapper />
}

export default SkeftoLoader
